export const dropdownTokens = {
  'dropdown-bg': 'var(--dp-color-background)',
  'dropdown-border-color': 'var(--dp-color-border)',
  'dropdown-border-radius': 'var(--dp-border-radius-md)',
  'dropdown-shadow': 'var(--dp-shadow-lg)',
  'dropdown-item-padding': 'var(--dp-spacing-sm) var(--dp-spacing-md)',
  'dropdown-item-hover-bg': 'var(--dp-color-surface-hover)',
  'dropdown-item-active-bg': 'var(--dp-color-primary-light)',
  'dropdown-max-height': '320px',
  'dropdown-z-index': '100',
  'dropdown-trigger-height': '36px',
} as const;
